export const CRITERIA_ID_PARAM = 'criteriaId';
export const TRANSCRIPTION_ID_PARAM = 'transcriptionId';

export interface ReviewLocation {
  criteriaId: string;
  transcriptionId: string;
}

export const readReviewLocation = (): ReviewLocation => {
  const params = new URLSearchParams(window.location.search);
  return {
    criteriaId: params.get(CRITERIA_ID_PARAM) ?? '',
    transcriptionId: params.get(TRANSCRIPTION_ID_PARAM) ?? '',
  };
};

export const writeReviewLocation = (criteriaId: string, transcriptionId: string): void => {
  const url = new URL(window.location.href);
  if (criteriaId) {
    url.searchParams.set(CRITERIA_ID_PARAM, criteriaId);
  } else {
    url.searchParams.delete(CRITERIA_ID_PARAM);
  }
  if (transcriptionId) {
    url.searchParams.set(TRANSCRIPTION_ID_PARAM, transcriptionId);
  } else {
    url.searchParams.delete(TRANSCRIPTION_ID_PARAM);
  }
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
};
